/**
 * Avalara © 2018
 * file: engines/opus_ui/src/search/AvataxAccountCard.js
 */

import React, { useState } from 'react';
import loadingGif from '../../assets/loading.gif';

import AvataxCard from './AvataxCard';
import { makePostRequest } from '../../helpers/biztechAxiosRequest';
import { sendNotification } from '../../utils/notification';
import { deprovisionOrphanedAccountEndpoint } from '../../constants/ApiEndpoints';

const CARD_NAME = 'Avatax Account';

const AvataxAccountCard = ({ data, type }) => {
  const [loading, setLoading] = useState(false);
  const deprovisionOrphanedAccount = async () => {
    setLoading(true);
    try {
      const response = await makePostRequest(
        deprovisionOrphanedAccountEndpoint(data.id)
      );

      if (response.status === 200) {
        window.location.reload();
      } else {
        return sendNotification("Can't deprovision account");
      }
    } catch (error) {
      return sendNotification("Can't deprovision account");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="Card">
      <div className="SectionTitle">
        <div>
          {CARD_NAME}
          <h1>{data.id}</h1>
        </div>
        <div className="logo-container">
          {!data.customerAccount &&
            (loading ? (
              <>
                <img src={loadingGif} alt="Please wait" /> Deprovisioning...
              </>
            ) : (
              <button
                className="icon-trailing DeprovisionButton"
                onClick={deprovisionOrphanedAccount}
              >
                Deprovision
              </button>
            ))}
        </div>
      </div>
      <div className="ResultsSection">
        <div className="DeliveryResultsSection">
          <AvataxCard
            deliveryInfo={{
              ...data,
              displayName: data.deliverySystem
            }}
          />
          {/* {data.customerAccount && data.customerAccount.id ? (
            <a
              href={`https://edw.sanjuan.avalara.com/ReportServer/Pages/ReportViewer.aspx?%2fBillableUsage%2fBT+UsageDetail&rs:Command=Render&CustomerAccountID=${data.customerAccount.id}`}
            >
              View in Usage Report
            </a>
          ) : (
            undefined
          )} */}
        </div>
      </div>
    </div>
  );
};

export default AvataxAccountCard;
